import { AlertTriangle, CircleAlert, Info, type LucideIcon } from 'lucide-react'
import type { NoticeType } from '@/types/notice'

interface NoticeTone {
	icon: LucideIcon
	/** Fundo/borda do banner */
	surface: string
	/** Borda de destaque à esquerda do banner */
	accent: string
	/** Círculo que envolve o ícone */
	iconWrap: string
	/** Anel pulsante atrás do ícone */
	pulse: string
	/** Cor sólida (barras, progresso, botões) */
	solid: string
	/** Texto do rótulo de tipo */
	text: string
	/** Listras de "fita de sinalização" do modal */
	stripes: string
}

// Cores KAEFER por tipo de aviso, reaproveitadas pelo banner (medium) e pelo modal (high)
export const NOTICE_TONE: Record<NoticeType, NoticeTone> = {
	info: {
		accent: 'border-l-kaefer-sapphire-blue',
		icon: Info,
		surface:
			'border-kaefer-sapphire-blue/25 bg-linear-to-r from-kaefer-sapphire-blue/10 via-kaefer-astral-blue/5 to-transparent',
		iconWrap: 'bg-kaefer-sapphire-blue text-white',
		pulse: 'bg-kaefer-sapphire-blue/40',
		solid: 'bg-kaefer-sapphire-blue',
		text: 'text-kaefer-sapphire-blue',
		stripes:
			'bg-[repeating-linear-gradient(-45deg,var(--color-kaefer-sapphire-blue)_0_14px,var(--color-kaefer-astral-blue)_14px_28px)]',
	},
	warning: {
		accent: 'border-l-kaefer-honey-yellow',
		icon: AlertTriangle,
		surface:
			'border-kaefer-honey-yellow/40 bg-linear-to-r from-kaefer-honey-yellow/15 via-kaefer-sunny-yellow/5 to-transparent',
		iconWrap: 'bg-kaefer-honey-yellow text-kaefer-dark-grey',
		pulse: 'bg-kaefer-honey-yellow/50',
		solid: 'bg-kaefer-honey-yellow',
		text: 'text-amber-700',
		stripes:
			'bg-[repeating-linear-gradient(-45deg,var(--color-kaefer-honey-yellow)_0_14px,var(--color-kaefer-dark-grey)_14px_28px)]',
	},
	danger: {
		accent: 'border-l-kaefer-red',
		icon: CircleAlert,
		surface:
			'border-kaefer-red/30 bg-linear-to-r from-kaefer-red/10 via-kaefer-red/5 to-transparent',
		iconWrap: 'bg-kaefer-red text-white',
		pulse: 'bg-kaefer-red/40',
		solid: 'bg-kaefer-red',
		text: 'text-kaefer-red',
		stripes:
			'bg-[repeating-linear-gradient(-45deg,var(--color-kaefer-red)_0_14px,#ffffff_14px_28px)]',
	},
}
